import { useState } from 'react';
import { toast } from 'sonner';
import { Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useFetch } from '@/hooks/use-fetch';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

// Trash-icon remove for the verified alert phone: confirm dialog, then
// DELETE /auth/phone. Used on the launchpad row and in Edit profile.
export function RemoveAlertPhoneButton({ onRemoved }: { onRemoved: () => void }) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const fetchWithAuth = useFetch();

  async function remove() {
    try {
      const res = await fetchWithAuth('/auth/phone', { method: 'DELETE' });
      if (!res.ok) {
        toast.error('Failed to remove the alert phone');
        return;
      }
      onRemoved();
      toast.success('Alert phone removed');
    } catch {
      toast.error('Failed to remove the alert phone');
    }
  }

  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        aria-label="Remove alert phone"
        className="text-muted-foreground hover:text-destructive"
        onClick={() => setConfirmOpen(true)}
      >
        <Trash2 />
      </Button>
      <AlertDialog open={confirmOpen} onOpenChange={setConfirmOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Remove alert phone?</AlertDialogTitle>
            <AlertDialogDescription>
              If you remove your number, we will not be able to text you when something breaks.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Keep it</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => {
                setConfirmOpen(false);
                void remove();
              }}
            >
              Remove
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
